import { IconButton } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

const HelpLink = ({ to, size = "small", sx = {}, color = "inherit" }) => {
  const iconSize = size === "large" ? 28 : undefined;
  const buttonSize = size === "large" ? "medium" : size;

  return (
    <IconButton
      component={RouterLink}
      to={to}
      size={buttonSize}
      sx={{
        color: `${color} !important`,
        marginRight: "8px",
        opacity: 1,
        "&:hover": {
          opacity: 0.6,
        },
        ...sx,
      }}
      aria-label="Help"
      title="Learn more"
    >
      <HelpOutline
        sx={iconSize ? { fontSize: iconSize } : undefined}
        fontSize={iconSize ? undefined : size}
      />
    </IconButton>
  );
};

export default HelpLink;
